/* eslint-disable import/order */
/* eslint-disable import/first */
// import './src/why-did-you-render'; // uncomment to diagnose re-render issues

// anything that must run first before everything else
import './src/styles';
import 'react-native-reanimated';
import 'react-native-get-random-values';
import { enableFreeze, enableScreens } from 'react-native-screens';

// DO NOT MOVE THESE LINES for some reason web requires this or it bombs on local storage calls.
import Cognito from './src/utils/cognito/storage';
Cognito.getItem('FAKE');

import { staticLDFlags } from './src/state/launchdarkly/launchdarkly-core';
import safeFlagDefaults from './src/state/launchdarkly/safe-flag-defaults';
import { StorageKeys } from './src/utils/local-storage';
import { WebLocalStorage } from './src/utils/local-storage/web-local-storage';

// prioritize initializing async LD flags before app loads much...
WebLocalStorage.sync().then(() => {
  staticLDFlags.current =
    WebLocalStorage.getItem(StorageKeys.LAUNCH_DARKLY_FLAGS) ?? safeFlagDefaults;
});

enableScreens(true);
enableFreeze(true);

// normal app start invokes src/app/_layout.tsx
// eslint-disable-next-line import/first
import 'expo-router/entry';
